import InputAdornment from '@mui/material/InputAdornment';
import Typography from '@mui/material/Typography';
import { PickersTextField, type PickersTextFieldProps } from '@mui/x-date-pickers/PickersTextField';
import { useTranslation } from 'react-i18next';

export const UtcTextFieldSlot = ({ endAdornment, slotProps, ...rest }: PickersTextFieldProps) => {
  const { t } = useTranslation();

  // The picker forwards its computed end adornment (e.g. the calendar toggle button)
  // both as a top-level prop and via `slotProps.input.endAdornment`; the latter wins when
  // `PickersTextField` merges them, so it must be the one we intercept and wrap.
  const pickerEndAdornment = slotProps?.input?.endAdornment ?? endAdornment;

  const wrappedEndAdornment = (
    <InputAdornment position="end" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          whiteSpace: 'nowrap',
        }}
      >
        {t('UTC')}
      </Typography>
      {pickerEndAdornment}
    </InputAdornment>
  );

  return (
    <PickersTextField
      {...rest}
      endAdornment={wrappedEndAdornment}
      slotProps={{
        ...slotProps,
        input: {
          ...slotProps?.input,
          endAdornment: wrappedEndAdornment,
        },
      }}
    />
  );
};
